
import { addOddsDiff, checkChpType, showTournPoolByPage } from '../common';
import { updatePoolInfo, updateCheckBoxSelection } from '../parseUpdMatchPool'
import {setTournamentPageTabs, trimTournamentByTourn} from '../../../Common/Common';
import { parseUpdTournPool } from '../parseUpdTournPool'
import { updatePoolOdds } from '../parseUpdMatchPoolV2/updateMatchPool'

export const parseUpdTournPoolV2 = (message, topicInfo, contentRef, option) =>{
    if(option?.esReplay) return
    if(!topicInfo.oddsUpd){
        parseUpdTournPool(message, topicInfo, contentRef, option)
        return
    }
    const isTournamentPage = contentRef.current.page === 'TOURNAMENT'
    let tourn = contentRef.current.tournData?.tournaments?.find(x => x.id == topicInfo.tournamentid);
    let currentPool = tourn?.foPools?.find(item => item.id === message.id)

    if(!tourn || !currentPool) return
    let newPool = updatePoolOdds(currentPool, message)

    addOddsDiff(contentRef, tourn, currentPool, newPool, option)
    currentPool.lines = newPool.lines
}